var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z",
    fill: "#8A96A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.7766,
    cy: 2.7766,
    r: 2.7766,
    transform: "matrix(-1 0 0 1 16.7227 11.1704)",
    fill: "#8A96A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z",
    stroke: "#8A96A3",
    strokeWidth: 3.39362,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image_upload.717ef5035cd58c11e9c8cec6ebd79ebd.svg";
export { ForwardRef as ReactComponent };